import React, { useState,useEffect } from "react";
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import Edit from "../../../assets/images/editinput.svg";
import { Select } from "@appkit4/react-components/select";
import "../../../../src/styles/userManagement.css";
import List from "./List";
import { handleNotificationSubmit } from "../../Plan/notification/notification.js";

import APIService from "../../../services/apiAxiosService";

import useHttp from "../../../hooks/useHttp.js";

export default function Questionnaire(props) {
  let { SetTab, reloadData, fetchUserList } = props;
  const [loading, setLoading] = useState(false);
  const [questionnaire, setQuestionnaire] = useState("");
  const [question, setQuestion] = useState("");
  const { sendRequest: handleQuestionnaire } = useHttp();
const[questionCount,setQuestionCount]=useState();
  const [errorQuestionnaire, setErrorQuestionnaire] = useState("");
  const [errorQuestion, setErrorQuestion] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [highScore, setHighScore] = useState(0);
  const [mediumScore, setMediumScore] = useState(0);
  const [lowScore, setLowScore] = useState(0);

  const [data, setData] = React.useState([
    [
      {
        label: "Select Value",
        value: "",
      },
    ],
  ]);

 

  const handleSubmit = async () => {
    if (questionnaire.trim() === "") {
      setErrorQuestionnaire("Question Type is required");
      setIsErrorMessageShown(true);
      return false;
    }
    if (question.trim() == "") {
      setErrorQuestion("Question is required");
      setIsErrorMessageShown(true);
      return false;
    }
    var flag=0;
    var dataVal = new Array();
    for (var i = 0; i < data.length; i++) {
      for (var j = 0; j < data[i].length; j++) {
        if(data[i][j].value=='' && questionnaire=='select')
          {
          let Msg = "Please add dropdown value";
          displayToastMessage(Msg, "error");
          var flag=1;

          break;
          }else{
            dataVal.push({ id: i + 1, value: data[i][j].value });

          }
      }
    }
    var scorObj = [
      {id:1, score:Number(highScore)},
      {id:2, score:Number(mediumScore)},
      {id:3, score:Number(lowScore)}
    ]

    if(flag==0)
      {
    let payload = {
      questionnaireType: questionnaire,
      question: question,
      orgId: Number(sessionStorage.getItem("orgId")),
      user: Number(sessionStorage.getItem("userId")),
      dataDetails: JSON.stringify(dataVal),
      score:JSON.stringify(scorObj)
    };

    try {
      handleQuestionnaire(
        APIService.questionnaireSubmit(payload),
        responseHandler
      );
    } catch (error) {
      console.log("Error", error);
      setLoading(false);
      let Msg = "Please create new questionnaire!";
      displayToastMessage(Msg, "error");
    }
  }
  };

  const responseHandler = (data) => {
    if (data.CODE) {

      setQuestionnaire("");
      setQuestion("");
      setErrorQuestionnaire("");
      setErrorQuestion("");
      setIsErrorMessageShown("");
      setLoading(false);
       reloadData();
       displayToastMessage("Questionnaire created successfully", "success");

      
    } else {
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };

  var qus = [
    {
      id: "1",
      name: "select",
    },
    {
      id: "2",
      name: "text",
    },
  ];


  // handle change for frequency
  const handleQuestionnaireValidation = (e) => {
    if (e != "") {
      setQuestionnaire(e);
      setErrorQuestionnaire("");
    } else {
      setIsErrorMessageShown(true);
      setErrorQuestionnaire("Special characters are not allowed");
    }
  };
  const handleChangeQuestion = (e) => {
    if (e.target.value || e.target.value === "") {
      setQuestion(e.target.value);
      setErrorQuestion("");
    } else {
      setIsErrorMessageShown(true);
      setErrorQuestion("Special characters are not allowed");
    }
  };

  const handleChangeHighScore = (e) => {
    if (e.target.value || e.target.value === "") {
      setHighScore(e.target.value);
      setErrorQuestion("");
    } else {
      setIsErrorMessageShown(true);
      setErrorQuestion("Special characters are not allowed");
    }
  };

  const handleChangeMediumScore = (e) => {
    if (e.target.value || e.target.value === "") {
      setMediumScore(e.target.value);
      setErrorQuestion("");
    } else {
      setIsErrorMessageShown(true);
      setErrorQuestion("Special characters are not allowed");
    }
  };

  const   handleChangeLowScore  = (e) => {
    if (e.target.value || e.target.value === "") {
      setLowScore(e.target.value);
      setErrorQuestion("");
    } else {
      setIsErrorMessageShown(true);
      setErrorQuestion("Special characters are not allowed");
    }
  };

  const handleReset = () => {
    SetTab(0);
  };

  const handleOnChange = (e, row, col) => {
    const newData = data.map((d, i) => {
      if (i === row) {
        d[col].value = e;
      }

      return d;
    });
    setData(newData);
  };

  const addRow = () => {
    setData([
      ...data,
      [
        {
          value: "",
        },
      ],
    ]);
  };

  const removeRow = (index) => {
    const _data = [...data];
    _data.splice(index, 1);
    setData(_data);
  };

  return (
    <div className="App">
      <div className="row">
        <div className="col-sm-6 mt-5">
          <div className="cv-input-field-container pt-0 pb-0">
            <label htmlFor="Questionnaire" className="cv-input-label">
              Question Type<span className="asterisk-required">*</span>
            </label>

            <Select
              className="cv-input-field"
              dropdownRenderMode="portal"
              searchable={true}
              type="text"
              value={questionnaire}
              data={qus}
              valueKey="name"
              labelKey="name"
              showSearchOnToggle={true}
              placeholder="Select Questionnaire"
              onSelect={(e) => handleQuestionnaireValidation(e)}
              name="questionnaire"
            ></Select>
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          <div className="cv-input-field">
            <span
              className="form-label errorMsg"
              style={{
                display: isErrorMessageShown ? "block" : "none",
              }}
            >
              {errorQuestionnaire}
            </span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 mt-5">
          <div className="cv-input-field-container pt-0 pb-0">
            <label htmlFor="questionSegment" className="cv-input-label">
              Question <span className="asterisk-required">*</span>
            </label>
            <input
              className={"cv-input-field pl-2 autofocus"}
              type="text"
              id="questionSegment"
              name="question"
              value={question}
              onChange={handleChangeQuestion}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>

          <div className="cv-input-field">
            <span
              className="form-label errorMsg"
              style={{
                display: isErrorMessageShown ? "block" : "none",
              }}
            >
              {errorQuestion}
            </span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 mt-5">
          <div className="cv-input-field-container pt-0 pb-0">
            <label htmlFor="high" className="cv-input-label">
             High Score <span className="asterisk-required">*</span>
            </label>
            <input
              className={"cv-input-field pl-2 autofocus"}
              type="number"
              name="high"
              value={highScore}
              onChange={handleChangeHighScore}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>

          <div className="cv-input-field">
            <span
              className="form-label errorMsg"
              style={{
                display: isErrorMessageShown ? "block" : "none",
              }}
            >
              {errorQuestion}
            </span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 mt-5">
          <div className="cv-input-field-container pt-0 pb-0">
            <label htmlFor="medium" className="cv-input-label">
             Medium Score <span className="asterisk-required">*</span>
            </label>
            <input
              className={"cv-input-field pl-2 autofocus"}
              type="number"
              name="medium"
              value={mediumScore}
              onChange={handleChangeMediumScore}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>

          <div className="cv-input-field">
            <span
              className="form-label errorMsg"
              style={{
                display: isErrorMessageShown ? "block" : "none",
              }}
            >
              {errorQuestion}
            </span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 mt-5">
          <div className="cv-input-field-container pt-0 pb-0">
            <label htmlFor="low" className="cv-input-label">
             Low Score <span className="asterisk-required">*</span>
            </label>
            <input
              className={"cv-input-field pl-2 autofocus"}
              type="number"
              name="low"
              value={lowScore}
              onChange={handleChangeLowScore}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>

          <div className="cv-input-field">
            <span
              className="form-label errorMsg"
              style={{
                display: isErrorMessageShown ? "block" : "none",
              }}
            >
              {errorQuestion}
            </span>
          </div>
        </div>
      </div>
      {questionnaire == "select" && (
        <div className="row">
          <div className="col-sm-12 mt-5">
            <List
              data={data}
              addRow={addRow}
              removeRow={removeRow}
              handleOnChange={handleOnChange}
            />
          </div>
        </div>
      )}
      <div className="options-container">
        <button className="cancel-button" type="reset" onClick={handleReset}>
          Cancel
        </button>
        <button
          type="submit"
          className="save-button m-l-2"
          onClick={handleSubmit}
        >
          Save
        </button>
 
      </div>
    </div>
  );
}
